import { Component, Vue } from 'vue-property-decorator';
import { isEmpty, isString } from 'lodash';

interface StyleParam {
  backgroundColor?: string;
}

@Component
export default class colorMainMenuMixin extends Vue {
  get menuMainColor(): string {
    const { regionProfile } = this.$store.state;
    return !isEmpty(regionProfile) && isString(regionProfile.colorMenuMain)
      ? `#${regionProfile.colorMenuMain}`
      : '#6153ac';
  }

  get mainMenuStyle(): StyleParam {
    const { menuMainColor } = this;
    return !!menuMainColor.length ? { backgroundColor: `${menuMainColor}` } : {};
  }
}



// WEBPACK FOOTER //
// ./src/mixins/colorMainMenu.ts